import React from 'react';
import { motion } from 'framer-motion';
import './WhatsApp.css';

const WhatsApp = () => {
  const whatsappNumber = '966563535568';
  const message = 'مرحباً، أرغب في الاستفسار عن خدماتكم';
  
  const handleClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <motion.div
      className="whatsapp-float"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 2, type: "spring" }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={handleClick}
    >
      <svg viewBox="0 0 24 24" width="30" height="30" fill="white">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
        <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10c-1.766 0-3.442-.46-4.897-1.283l-4.103 1.283 1.305-4.038c-.887-1.485-1.305-3.174-1.305-4.962 0-5.514 4.486-10 10-10m0-2c-6.627 0-12 5.373-12 12 0 2.125.555 4.119 1.527 5.85l-1.527 4.85 5.006-1.562c1.697.902 3.626 1.362 5.994 1.362 6.627 0 12-5.373 12-12s-5.373-12-12-12z"/>
      </svg>
    </motion.div>
  );
};

export default WhatsApp;
